export const LMT_ENHCMT_selectTheBankReducer = {
  LMT_ENHCMT_selectTheBank: (state, action) => {
    state.selectedBankObj = action.payload;
  },
};
